/* global $ */

import equaliseRows from './equaliseRows'
import setEqualHeight from './setEqualHeight'

function onWindowResize() {
    // if ($(window).width() > 992) {
    //     equaliseRows()
    // }

    equaliseRows()

    $('.mid_wrapper').each(function() {
        setEqualHeight($(this).find('.owl-item'));
    });

    if ($('.intro_wrapper').length) {
        $('.intro_wrapper').data('owlCarousel').reinit();
    }
    if ($('.intro_wrapper_no_auto').length) {
        $('.intro_wrapper_no_auto').data('owlCarousel').reinit();
    }
}

export default onWindowResize;



// WEBPACK FOOTER //
// ./src/modules/plugins/onWindowResize.js